import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { Collapse, List, ListItemText, ListProps } from "@mui/material";
import { Chip, FlexRow, ListItem, OverflowText, Text } from "designSystem/index";
import { white } from "designSystem/styles/color";
import React, { FunctionComponent, ReactNode } from "react";

export interface ExpandableListProps extends ListProps {
    /* Whether a count should be displayed for the list root */
	displayCounts?: boolean;
	/* Whether the list is expanded */
	expanded?: boolean;
	/* The list items */
	items: ReactNode[];
	/* The status res of the list */
	labelStatusRes?: string;
	/* The status color */
	labelStatusColor?: string;
	/* The title of the list */
	title?: string;
	/* The title color */
	titleColor?: string;
}

export const ExpandableList: FunctionComponent<ExpandableListProps> = (props) => {
	const {
		displayCounts,
		expanded,
		items,
		labelStatusRes,
		labelStatusColor,
		title,
		titleColor,
		...otherProps
	} = props;

	const [open, setOpen] = React.useState(expanded);

	const handleClick = () => {
	  setOpen(!open);
	};

	return (
		<List
			component="nav"
			sx={{ bgcolor: white[50],
				 borderRadius: 1 }}
			{...otherProps}
		>
			<ListItem onClick={handleClick}>
				<ListItemText
					sx={{
						"& .MuiTypography-root": {
							display: "flex",
							justifyContent: "space-between",
							gap: 1,
							alignItems: "center",
							width: "100%",
						},
					}}
				>
					<OverflowText
						bold
						color={titleColor}
						text={title}
					/>
					<FlexRow gap={1}>
						{labelStatusRes && (
							<Text
								color={labelStatusColor}
								fontStyle="italic"
								res={labelStatusRes}
							/>
						)}
						{displayCounts && <Chip label={items?.length || 0} /> }
					</FlexRow>
				</ListItemText>
				{open ? <ExpandLess /> : <ExpandMore />}
			</ListItem>
			<Collapse
				in={open}
				timeout="auto"
			>
				<List
					component="nav" 
					sx={
						{ "& .MuiListItem-root:not(:last-child)": { paddingBottom: 0 } }
					}
				>
					{items}
				</List>
			</Collapse>
		</List>
	);
};